export const CROP_LOGO = 'CROP_LOGO';
export const TOGGLE_CROPPER_MODAL = 'TOGGLE_CROPPER_MODAL';
